import React, { Component } from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import Options from '../../Components/Options';
import { getPartner } from '../../service/partners/selector';
import PartnerContainer from '../PartnerContainer';
import Binding from '../../Components/Binding';
import Export from '../../Components/Export';

class LyonEats extends Component {
	render() {
		const { partner, exportActive } = this.props;
		return (
			<PartnerContainer
				name={I18n.t(`partner.prefix.${partner.prefix}`)}
				id={partner ? partner.id : null}
				prefix={partner ? partner.prefix : null}>
				<Export {...this.props} />
				<div className="gestion-button">
					<Binding prefix={partner.prefix} />
				</div>

				<Options prefix_partner={partner.prefix || ''} />
			</PartnerContainer>
		);
	}
}

const mapStateToProps = (state, props) => {
	const partner = getPartner(state, props);
	return {
		partner,
		list: state.exports.list,
	};
};

export default connect(mapStateToProps)(LyonEats);
